import axios from "axios";
import { Tag } from "ant-design-vue";

// POST    	/file/create
// POST    	/file/update/{uuid}
// GET     	/file/list
// GET     	/file/get/{uuid}
// DELETE  	/file/delete/{uuid}
// GET     	/folder/list
// GET     	/folder/get/{uuid}
// POST    	/folder/create
// POST    	/folder/update/{uuid}
// DELETE  	/folder/delete/{uuid}
// GET|POST	/login
// GET     	/tag/list
// GET     	/tag/get/{uuid}
// POST    	/tag/create
// POST    	/tag/update/{uuid}
// DELETE  	/tag/delete/{uuid}
// POST    	/user/create
// POST    	/user/update/{id}
// GET     	/user/get/{uuid}
// DELETE  	/user/delete/{uuid}
// ANY     	/media/init
// POST    	/media/upload
// GET     	/media/get/{uuid}
// POST    	/media/create
// POST    	/media/update/{uuid}
// DELETE  	/media/delete/{uuid}

// Ufo:
// /folderinfo/add-info-to-folder
// /folderinfo/remove-info-from-folder

// Mindkét végpont POST és két kötelező paramétere van:
// folder_id: id
// info_ids: []

//GET

export const getInfoExport = (options, uuid) => {
  return axios.get(`/api/folderinfo/export/${uuid}`, options);
}

export const getGlobalProperties = options => {
  return axios.get("/api/search/global-properties", options);
};

export const getTags = options => {
  return axios.get("/api/tag/list", options);
};
export const getFolders = options => {
  console.log("INFOPTS", options);
  return axios.get("/api/folderinfo/list", options);
};
export const getFolderById = (options, uuid) => {
  return axios.get(`/api/folderinfo/get/${uuid}`, options);
};
export const getUsers = options => {
  return axios.get("/api/user/list", options);
};

//POST
export const searchGlobal = options => {
  return axios.post("/api/search/global", options);
};

export const validateSms = (options) => {
  return axios.post('api/sms/validate', options).then(res => {
    if (res.data.result === false) {
      console.log('BAD SMS TOKEN');
      return Promise.reject(res.data)
    } else {
      console.log('OK SMS TOKEN');
      return res;
    }
  });
}

// export const mediaUpload = (options) => {
//     return axios.post('/api/media/upload', options)
// };
export const fileUpload = (options, uuid, config) => {
  return axios.post(`/api/folderinfo/upload/${uuid}`, options, config);
};

export const removeFileFromInfo = options => {
  return axios.post(`/api/folderinfo/remove-file-from-info`, options);
};

export const createFolder = options => {
  return axios.post("/api/folderinfo/create", options);
};

export const addInfosToFolder = options => {
  return axios.post("/api/folderinfo/add-info-to-folder", options);
};
export const removeInfoFromFolder = options => {
  return axios.post("/api/folderinfo/remove-info-from-folder", options);
};

export const createTag = options => {
  return axios.post("/api/tag/create", options);
};

export const updateTag = (options, uuid) => {
  return axios.post(`/api/tag/update/${uuid}`, options);
};

export const updateFolder = (options, uuid) => {
  return axios.post(`/api/folderinfo/update/${uuid}`, options);
};

export const createUser = options => {
  return axios.post("/api/user/create", options);
};

export const modifyUser = (options, uuid) => {
    return axios.post(`/api/user/update/${uuid}`, options);
}

//UPDATE

//DELETE
export const deleteTag = (options, uuid) => {
  return axios.delete(`/api/tag/delete/${uuid}`, options);
};

export const deleteFolder = (options, uuid) => {
  return axios.delete(`/api/folderinfo/delete/${uuid}`, options);
};

export const deleteUser = (options, uuid) => {
  return axios.delete(`/api/user/delete/${uuid}`, options);
}